/** Standard desktop selection: click replaces, Ctrl/Meta toggles, Shift selects a range. */
export function cargoSelection(current: string[], id: string, ordered: string[], anchor?: string,
  modifiers: { ctrlKey?: boolean; metaKey?: boolean; shiftKey?: boolean } = {}) {
  const additive = modifiers.ctrlKey || modifiers.metaKey
  if (modifiers.shiftKey && anchor && ordered.includes(anchor) && ordered.includes(id)) {
    const start = ordered.indexOf(anchor), end = ordered.indexOf(id)
    const range = ordered.slice(Math.min(start, end), Math.max(start, end) + 1)
    return { ids: additive ? [...new Set([...current, ...range])] : range, anchor }
  }
  return { ids: additive ? current.includes(id) ? current.filter(value => value !== id) : [...current, id] : [id], anchor: id }
}
